import { $, $$ } from './dom.js';

function getDuration(slide, fallback) {
  const duration = Number(slide?.dataset.duration);
  return Number.isFinite(duration) && duration > 0 ? duration : fallback;
}

function enableTouch(root, onPrevious, onNext) {
  let startX = 0;
  root.addEventListener('touchstart', (event) => { startX = event.changedTouches[0]?.clientX || 0; }, { passive: true });
  root.addEventListener('touchend', (event) => {
    const delta = (event.changedTouches[0]?.clientX || startX) - startX;
    if (Math.abs(delta) > 45) (delta < 0 ? onNext : onPrevious)();
  }, { passive: true });
}

export function initHeroSlider() {
  const root = $('#anasayfa.hero-slider');
  if (!root) return;

  const slides = $$('.hero-slide', root);
  const previous = $('#heroPrev');
  const next = $('#heroNext');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  let index = 0;
  let timer;
  let paused = reducedMotion.matches;

  function clearTimer() { window.clearTimeout(timer); }
  function setSlide(nextIndex) {
    index = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.inert = !active;
      const video = $('video', slide);
      if (video && !active) video.pause();
    });
    schedule();
  }
  function schedule() {
    clearTimer();
    if (paused || document.hidden || slides.length < 2) return;
    const activeSlide = slides[index];
    const video = $('video', activeSlide);
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => { timer = window.setTimeout(() => setSlide(index + 1), getDuration(activeSlide, 6000)); });
      return;
    }
    timer = window.setTimeout(() => setSlide(index + 1), getDuration(activeSlide, 6000));
  }

  slides.forEach((slide, slideIndex) => {
    $('video', slide)?.addEventListener('ended', () => { if (slideIndex === index) setSlide(index + 1); });
  });
  previous?.addEventListener('click', () => setSlide(index - 1));
  next?.addEventListener('click', () => setSlide(index + 1));
  root.addEventListener('mouseenter', () => { paused = true; clearTimer(); });
  root.addEventListener('mouseleave', () => { paused = reducedMotion.matches; schedule(); });
  root.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') setSlide(index - 1);
    if (event.key === 'ArrowRight') setSlide(index + 1);
  });
  document.addEventListener('visibilitychange', schedule);
  reducedMotion.addEventListener('change', () => { paused = reducedMotion.matches; schedule(); });
  root.setAttribute('aria-roledescription', 'slayt gösterisi');
  root.setAttribute('tabindex', '0');
  enableTouch(root, () => setSlide(index - 1), () => setSlide(index + 1));
  setSlide(0);
}

export function initProjectSlider() {
  const root = $('#projectShowcase');
  if (!root) return;
  const slides = $$('.showcase-slide', root);
  const dots = $$('.project-dots button', root);
  const current = $('#projectCurrent');
  let index = 0;

  function setSlide(nextIndex) {
    index = (nextIndex + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.classList.toggle('is-active', active);
      slide.setAttribute('aria-hidden', String(!active));
      slide.inert = !active;
    });
    dots.forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === index));
    if (current) current.textContent = String(index + 1).padStart(2, '0');
  }

  $('#projectPrev')?.addEventListener('click', () => setSlide(index - 1));
  $('#projectNext')?.addEventListener('click', () => setSlide(index + 1));
  dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => setSlide(dotIndex)));
  root.setAttribute('aria-roledescription', 'proje slayt gösterisi');
  root.setAttribute('tabindex', '0');
  root.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') setSlide(index - 1);
    if (event.key === 'ArrowRight') setSlide(index + 1);
  });
  enableTouch(root, () => setSlide(index - 1), () => setSlide(index + 1));
  setSlide(0);
}
